import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { KanbanComment } from '@entities/kanban-comment'

import { useListsStore } from '@shared/model'

import { useTasksKanbanStore } from './store'
import { useSaveTasksKanbanCommentApi } from '../api/save-comment.hook'
import { useUpdateTasksKanbanCommentApi } from '../api/update-comment.hook'

interface SectionTaskInfoUpdateReturn {
  refLabel: ComputedRef<string>
  refId: ComputedRef<string | null>
  saveCommentApi: (comment: string) => Promise<KanbanComment | null>
  updateCommentApi: (commentId: number, comment: string) => Promise<KanbanComment | null>
}

export const useSectionTaskInfoUpdate = (): SectionTaskInfoUpdateReturn => {
  const tasksKanbanStore = useTasksKanbanStore()
  const listsStore = useListsStore()
  const route = useRoute()

  const refLabel = computed<string>(() => {
    const key = tasksKanbanStore.getTaskType
    if (!key) return ''
    return listsStore.getLists?.tasks_kanban?.lists?.task_type?.[key] ?? key
  })

  const refId = computed<string | null>(() => {
    const id = route.params.id
    if (typeof id !== 'string' || !id) return null
    return id
  })

  const saveCommentApi = async (comment: string): Promise<KanbanComment | null> => {
    if (!refId.value) return null
    return useSaveTasksKanbanCommentApi({ taskId: refId.value, comment })
  }

  const updateCommentApi = async (commentId: number, comment: string): Promise<KanbanComment | null> => {
    if (!refId.value) return null
    return useUpdateTasksKanbanCommentApi({ taskId: refId.value, commentId, comment })
  }

  return {
    refLabel,
    refId,
    saveCommentApi,
    updateCommentApi,
  }
}